import React from 'react'

// TODO: дальше импорты не из src/shared/components/desktop, потому что там в индексном файле подтягивается fetch,
//  который подтягивает superagent, который ломает сборку в SSR. Когда superagent заменим на что-то другое,
//  необходимость рендерить отдельный Header в /public отпадет и константы отсюда можно будет вернуть в <Header />
import ConnectionMethodsMenu from 'src/shared/components/header-menu/ConnectionsMethodsMenu'
import OtherBusinessesMenu from 'src/shared/components/header-menu/OtherBusinessMenu'
import ServicesMenu from 'src/shared/components/header-menu/ServicesMenu'
import {i18n} from 'src/shared/config'

import * as classes from './classes'

export const countryData = {
  button: {
    label: i18n('order.header.country.russia', 'Россия'),
  },
  list: [
    {
      href: 'https://delivery.yandex.com/am-ru/',
      label: i18n('order.header.country.armenia', 'Армения'),
    },
    {
      href: 'https://delivery.yandex.by/',
      label: i18n('order.header.country.belarus', 'Беларусь'),
    },
    {
      href: 'https://delivery.yandex.com/ge-en/',
      label: i18n('order.header.country.georgia', 'Грузия'),
    },
    {
      href: 'https://delivery.yandex.kg/',
      label: i18n('order.header.country.kyrgyzstan', 'Кыргызстан'),
    },
    {
      href: 'https://delivery.yandex.kz/',
      label: i18n('order.header.country.kazakhstan', 'Казахстан'),
    },
    {
      href: 'https://delivery.yandex.md/',
      label: i18n('order.header.country.moldova', 'Молдавия'),
    },
    {
      href: '/',
      label: i18n('order.header.country.russia', 'Россия'),
    },
    {
      href: 'https://delivery.yandex.com/rs-sr/',
      label: i18n('order.header.country.serbia', 'Сербия'),
    },
    {
      href: 'https://delivery.yandex.uz/',
      label: i18n('order.header.country.uzbekistan', 'Узбекистан'),
    },
  ],
}

export const controlPanelData = [
  {
    button: {
      label: i18n('order.header.button.become-a-courier', 'Стать курьером'),
    },
    list: [
      {
        href: '/for-courier/',
        label: i18n('order.header.button.on-foot-or-by-auto-courier', 'Пешим или автокурьером'),
      },
      {
        href: '/for-driver/personal-cargo/',
        label: i18n('order.header.button.truck-driver', 'Водителем грузовой машины'),
      },
    ],
  },
  {...countryData},
]
export const linksList = [
  {
    label: i18n('order.header.link.services', 'Услуги'),
    content: (
      <div className={classes.servicesMenu}>
        <ServicesMenu />
      </div>
    ),
  },
  {
    label: i18n('order.header.link.for-different-businesses', 'Для разных бизнесов'),
    content: (
      <div className={classes.otherBusinessesMenu}>
        <OtherBusinessesMenu />
      </div>
    ),
  },
  {
    label: i18n('order.header.link.connection-methods', 'Способы подключения'),
    content: (
      <div className={classes.connectionMethodsMenu}>
        <ConnectionMethodsMenu />
      </div>
    ),
  },
]
